var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeLense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_108_1",
    "data-name": "Component 108 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.612,
    height: 117.903,
    viewBox: "0 0 137.612 117.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45799",
    "data-name": "Rectangle 45799",
    width: 137.612,
    height: 117.903,
    fill: "#111c44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112327",
    "data-name": "Group 112327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112131",
    "data-name": "Group 112131",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52910",
    "data-name": "Path 52910",
    d: "M137.618,82.172V88.8c-.118.573-.242,1.146-.334,1.725-2.72,17.562-18.67,29.606-35.781,27.024-14.325-2.15-25.381-14.072-26.79-28.891-.164-1.995-.223-4-.328-6H63.252c-.138,2.453-.138,4.812-.433,7.13C60.486,107.545,44.594,120,27.327,117.6c-.1-.02-.216-.034-.321-.047C9.81,115.019-2.137,98.636.321,80.952A33.406,33.406,0,0,1,1.854,74.6C6.428,61.61,11.278,48.725,16.009,35.785,18.827,28.1,21.527,20.359,24.5,12.73A19.849,19.849,0,0,1,46.475.323a20.526,20.526,0,0,1,16.652,20.71q.02,12.222,0,24.443V47H74.491V45.241c0-8.013-.033-16.033.02-24.032a27.268,27.268,0,0,1,.511-5.061,19.958,19.958,0,0,1,38.612-2.163Q124.574,43.744,135.4,73.559q1.317,4.246,2.222,8.613m-31.5,23.911c11.042-.02,19.987-9.24,19.968-20.6v-.209c-.111-11.335-9.109-20.44-20.125-20.386C94.9,64.98,85.978,74.246,86.011,85.629c.131,11.329,9.089,20.447,20.112,20.454m-74.635,0c11.016,0,19.988-9.1,20.125-20.433.039-11.389-8.873-20.663-19.948-20.757C20.7,64.832,11.73,73.842,11.527,85.117c-.2,11.362,8.585,20.75,19.634,20.959.1.007.216.007.321.007Z",
    transform: "translate(0.001 0.001)",
    fill: "#111c44"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeLense);
export default __webpack_public_path__ + "static/media/ne-lense.b98a13a28a2c5cd1b5108cb5d4ebaa9f.svg";
export { ForwardRef as ReactComponent };